import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledRemoveAdsCta = styled(Link)`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  overflow: hidden;
  border: 1px solid #c79319;
  border-radius: 9999px;
  padding: 0.3rem 0.6rem 0.3rem 0.75rem;
  color: #342100;
  background: linear-gradient(135deg, #ffe7a3 0%, #f5c94f 52%, #d9a521 100%);
  box-shadow:
    0 2px 5px rgba(128, 83, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.65);
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  text-decoration: none;
  transition:
    transform 160ms ease,
    box-shadow 160ms ease,
    filter 160ms ease;

  &::before {
    position: absolute;
    inset: 0;
    width: 35%;
    content: '';
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.45),
      transparent
    );
    transform: translateX(-180%) skewX(-20deg);
    transition: transform 450ms ease;
  }

  &:hover {
    filter: saturate(1.08);
    transform: translateY(-1px);
    box-shadow:
      0 5px 12px rgba(128, 83, 0, 0.28),
      inset 0 1px 0 rgba(255, 255, 255, 0.7);
  }

  &:hover::before {
    transform: translateX(420%) skewX(-20deg);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(128, 83, 0, 0.2);
  }

  &:focus-visible {
    outline: 3px solid rgba(234, 179, 8, 0.55);
    outline-offset: 3px;
  }

  .remove-ads-cta__icon {
    position: relative;
    z-index: 1;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      rgba(255, 249, 220, 0.95) 0%,
      rgba(255, 231, 163, 0.45) 58%,
      transparent 75%
    );
  }

  .dark & {
    border-color: #e0ab2e;
    color: #291b00;
    background: linear-gradient(135deg, #ffedb2 0%, #e6b52f 54%, #b9820d 100%);
    box-shadow:
      0 3px 10px rgba(234, 179, 8, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.6);
  }

  @media (prefers-reduced-motion: reduce) {
    &,
    &::before {
      transition: none;
    }
  }
`;

export const RemoveAdsButton = ({ className = '' }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <StyledRemoveAdsCta to="/removeads" className={className}>
      {t('commonPhrases.removeAds')}
      <span className="remove-ads-cta__icon flex size-5 shrink-0 items-center justify-center">
        <img
          src="/images/icons/teuteuf_passport.png"
          width="14"
          height="14"
          alt=""
          className="rotate-[10deg]"
        />
      </span>
    </StyledRemoveAdsCta>
  );
};
